/* eslint-disable @typescript-eslint/ban-types */
import { Select } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { SingleFieldProps } from '../../../../Types'
import { useStyles } from './Style'
import { renderOptions } from './Utils'

const MultipleSelectField = <T extends {}>({
  field,
  input,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()

  /**
   * @description convert array to string for the input value
   * @param selectedValues
   */
  const renderValue = (selectedValues: unknown): string | null => {
    const newSelectedValues = selectedValues ? (selectedValues as []) : []
    if (
      newSelectedValues &&
      typeof selectedValues !== 'string' &&
      typeof selectedValues !== 'boolean'
    ) {
      return newSelectedValues
        .map((el) =>
          field.selectValue
            ? field.selectValue.find((singleEl) => singleEl.value === el)?.label
            : ''
        )
        .join(', ')
    }
    return null
  }

  const renderValueProps = () => {
    if (typeof input.value === 'string') {
      return input.value.split(',')
    }
    return input.value
  }

  return (
    <Select
      value={renderValueProps()}
      onChange={(event) => {
        input.onChange(event.target.value)
      }}
      name={field.name}
      variant="outlined"
      renderValue={renderValue}
      multiple
      className={clsx(classes.selectField, field.className || undefined)}
    >
      {renderOptions(input, field.selectValue)}
    </Select>
  )
}

export default MultipleSelectField
